import { render, staticRenderFns } from "./IconSmile.vue?vue&type=template&id=6875cd80&scoped=true"
import script from "./IconSmile.vue?vue&type=script&lang=js"
export * from "./IconSmile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6875cd80",
  null
  
)

export default component.exports